import PropTypes from 'prop-types';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import './InstitutionInfo.scss';

const InstitutionInfo = ({
  title = '',
  description = '',
  faculties = '',
  students = '',
  languages = '',
  courses = '',
  prices = '',
  web = '',
  email = '',
  direction = '',
  phone = ''
}) => {
  return (
    <div className="institution-info">
      <SectionHeading text={title} />
      <div className="institution-info-container">
        <div className="institution-info__description">
          <p>{description}</p>
        </div>

        <div className="institution-info__details">
          <ul>
            {faculties > 0 && (
              <li className="institution-info__details-faculties">
                Number of Faculties: <span>{faculties}</span>
              </li>
            )}

            {students > 0 && (
              <li className="institution-info__details-students">
                Numbers of students: <span>{students}</span>
              </li>
            )}

            {languages && (
              <li className="institution-info__details-languages">
                Languages Taught: <span>{languages}</span>
              </li>
            )}

            {courses && (
              <li className="institution-info__details-courses">
                Courses: <span>{courses}</span>
              </li>
            )}

            {prices && (
              <li className="institution-info__details-prices">
                Prices: <span>{prices}</span>
              </li>
            )}
          </ul>

          <div className="institution-info__contact">
            <p className="institution-info__contact-address">{direction}</p>
            <p>
              <a rel="nofollow noreferrer" target="_blank" href={web}>
                {web}
              </a>
            </p>
            <p>
              <a href={`mailto:${email}`}>{email}</a>
            </p>
            <p>
              <a href={`tel:${phone}`}>{phone}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

InstitutionInfo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  faculties: PropTypes.number,
  students: PropTypes.number,
  languages: PropTypes.string,
  courses: PropTypes.string,
  prices: PropTypes.string,
  web: PropTypes.string,
  email: PropTypes.string,
  direction: PropTypes.string,
  phone: PropTypes.string
};

export default InstitutionInfo;
